import axios from 'axios';

export const verifyCode = async (otp, captchaToken) => {
  const response = await axios.post('/auth/verify-code', {
    otp,
    captchaToken
  });

  return response;
};

export const resendVerifyCode = async (captchaToken) => {
  const response = await axios.post('/auth/resend-verify-code', {
    captchaToken
  });

  return response;
};
